import {doc} from '../../docs.js';
import SDFManager from '../../../custom/sdf/SDFManager.js';
import SDFBuilder from '../../../custom/sdf/SDFBuilder.js';
import RayMarchingManager from '../../../custom/sdf/RayMarchingManager.js';

doc(
    "gl.sdfManager",
    {
    },
    "Create and manage multiple SDF objects with mouse events",
    () => 0,
    {
        inlets: 0,
        altName: "sdf.manager",
        connects: [
            {
                outlet: "GL SDF Evaluators",
                object: "raymarching.manager",
                inlet: "GL SDF Evaluators"
            }
            ]
    });
export const sdfManager = (object) => {
    
    const sdf = new SDFManager(object);
    return (...args) => {
    };
};

doc(
    "gl.rayMarchingManager",
    {
    },
    "Manages ray marching for sdfs",
    () => 0,
    {
        inlets: 0,
        altName: "raymarching.manager",
       connects: [
            {
                outlet: "Data",
                object: "gl.directionalLighting",
                inlet: "Input"
            }
            ]
    });
export const rayMarchingManager = (object) => {
    
    const sdf = new RayMarchingManager(object);
    return (...args) => {
    };
};

doc(
    "gl.sdfBuilder",
    {
    },
    "Graphically build sdf objects (to send to sdf-manager)",
    () => 0,
    {
        inlets: 0,
        altName: "sdf.builder",
        connects: {
            object: "uniqueAppend",
        },
    });

export const sdfBuilder = (object) => {
    const sdf = new SDFBuilder(object);
    object.needsLoad = true;
    return () => {
        sdf.sendObject();
    };
};
